import $ from 'jquery';

function checkMenuPosition(item) {
	var $this = item;
    $this.find('.b-header__menu-inner-wrap').css('left', "-54px");
	var menuWidth = $this.find('.b-header__menu-inner-wrap').outerWidth();
	var menuPosition = $this.find('.b-header__menu-inner-wrap').offset().left;
	var leftPosition = 0;
	if ((menuWidth + menuPosition) > $(window).width()) {
		leftPosition = -(menuWidth + menuPosition - $(window).width() + 54);
		setTimeout(function() {
			$this.find('.b-header__menu-inner-wrap').css('left', leftPosition);
		}, 30);
	}
    if ($('.b-header').hasClass('menu-fixed')) {
        $this.find('.b-header__menu-inner-wrap').css('top', ($('.b-header__menu').height()));
    }
}

$(document).ready(function() {
    $(window).on('resize', function() {
    	checkMenuPosition($('.b-header__menu-item'));
    });
    $(document).on('mouseenter', '.js-header-menu-link', function() {
    	$('.js-header-menu-item').removeClass('active');
    	$(this).parents('.js-header-menu-item').addClass('active');
        checkMenuPosition($(this).parents('.js-header-menu-item'));
    });
    $(document).on('mouseenter', '.js-header-menu-link-empty', function() {
        $('.js-header-menu-item').removeClass('active');
    });
    $(document).on('mouseleave', '.b-header__menu', function() {
        $('.js-header-menu-item').removeClass('active');
    });
    $(document).on('click', '.b-header__menu-inner-item', function() {
        $('.js-header-menu-item').removeClass('active');
    });
    let lastScrollTop = 0, 
        st = 0,
        warningHeight = 0;
    $(window).on('scroll', function() {
        st = $(this).scrollTop();
        if (st > lastScrollTop) {
            $('.b-header').removeClass('show');
            $('.b-museum-menu--fixed').removeClass('show');
        }
        else {
            $('.b-header').addClass('show');
        }
        lastScrollTop = st;
        warningHeight = $('.b-warning').outerHeight();
        if (!warningHeight) {
            warningHeight = 0;
        }
        if ($(this).scrollTop() > (warningHeight + $('.b-header').outerHeight())) {
            $('.b-header').addClass('menu-fixed');
            $('.page').addClass('menu-fixed');
        } else {
            $('.b-header').removeClass('menu-fixed');
            $('.page').removeClass('menu-fixed');
        }
    });
    $('.js-header-menu-item').each(function() {
        if ($(this).find('.b-header__menu-inner-column').length === 1) {
            $(this).find('.b-header__menu-inner-list').addClass('one-column');
        } else if ($(this).find('.b-header__menu-inner-column').length === 2) {
            $(this).find('.b-header__menu-inner-list').addClass('two-columns');
        }
    });
});


// WEBPACK FOOTER //
// ./src/js/general/menu.js